import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQItemProps {
  question: string;
  answer: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div 
      data-testid="faq-item"
      className="border border-[var(--brand-primary)]/20 rounded-lg overflow-hidden bg-[var(--brand-primary)]/20 h-fit"
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
        className="w-full px-6 py-4 flex justify-between items-center text-left hover:bg-[var(--brand-primary)]/5 transition-colors duration-200"
        aria-expanded={isOpen}
        data-testid="faq-button"
      >
        <h3 className="text-lg font-medium text-[var(--text-primary)]">{question}</h3>
        <ChevronDown 
          data-testid="faq-icon"
          className={`w-5 h-5 text-[var(--text-primary)] transition-transform duration-200 ${
            isOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>
      <div 
        className={`grid transition-all duration-200 ${
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <div 
            className="px-6 py-4 text-[var(--text-primary)]"
            data-testid="faq-answer"
            dangerouslySetInnerHTML={{ __html: answer }}
          />
        </div>
      </div>
    </div>
  );
};

export default FAQItem;